import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExcellenceInMotion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="12398" id="the-art-of-the-smile" className="dark bg-background text-foreground relative h-[90vh] w-full overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/hero_architectural_tech.png)] bg-cover bg-center bg-fixed bg-no-repeat" />

      {}
      <div className="absolute inset-0 z-0 bg-black/40" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center justify-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-serif font-bold text-5xl md:text-7xl lg:text-8xl text-primary leading-tight mb-8 drop-shadow-2xl max-w-5xl tracking-tight">EL<br />&nbsp;<span className="text-white" data-ast-id="f:/src/pages/Home/sections/ExcellenceInMotion.tsx|sig:ec3kui" data-ast-start="1234" data-ast-end="1401">PROSTHODONTICS</span></h1>

        <div className="mt-4">
          <Button asChild className="bg-gradient-to-r from-[#91489D] to-[#B8479D] hover:opacity-90 text-white font-sans font-bold uppercase tracking-widest text-base md:text-lg h-auto py-4 px-10 rounded-md shadow-xl transition-all duration-300">
            <Link to="#">
              BOOK ONLINE
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}